<template>
  <div>
    <oil-cap
        title="Поставщики"
        :buttons="[
          {name:'создать платеж',route:'coming-payment-supplier'}
      ]"
    />
    <v-divider class="my-2"/>

    <oil-table
        :keys="[
        {
          text: 'Поставщик',
          value: 'SupplierName',

        },
        {
          text: 'Договор',
          value: 'ContractNumber',

        },
        {
          text: 'счет фактура',
          value: 'InvoiceNumber',
        },
        {
          text: 'Сумма',
          value: 'Amount',
        }
      ]"
        :items="payments"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="handleRowClick"
    />
  </div>
</template>

<script>
import {coreApi} from "~/services/core";

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table.vue'),
    OilCap: () => import('@/components/helper/oil.cap'),
  },
  data: () => ({
    payments: [],
    count:{
      count:0
    }
  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)


    // const payments = await coreApi.get(`coming-payment/supplier`)
    // this.payments = payments.data?.map(payment => {
    //   return {
    //     Id: payment.Id,
    //     SupplierName: payment.Supplier.Name,
    //     ContractNumber: payment.Contract.Number,
    //     InvoiceNumber: payment.Invoice.Number,
    //     Amount: payment.Amount,
    //   }
    // })
  },
  methods: {
    handleRowClick({Id}) {
      this.$router.push({
        name: 'coming-payment-supplier',
        params: {id: Id}
      })
    },
    async paginate(page) {
      const payments = await coreApi.get(`coming-payment/supplier/${page}`)
      const { count, dates } = payments.data
      this.count.count = count
      this.payments = dates?.map(payment => {
        return {
          Id: payment.Id,
          SupplierName: payment.Supplier.Name,
          ContractNumber: payment.Contract.Number,
          InvoiceNumber: payment.Invoice.Number,
          Amount: payment.Amount,
        }
      })
    },
  }
}
</script>
